module.exports = __webpack_public_path__ + "img/5.77d12b61.png";